import { render, staticRenderFns } from "./zhenxieguyu.vue?vue&type=template&id=c67fc5b2&scoped=true&"
import script from "./zhenxieguyu.vue?vue&type=script&lang=js&"
export * from "./zhenxieguyu.vue?vue&type=script&lang=js&"
import style0 from "./zhenxieguyu.vue?vue&type=style&index=0&id=c67fc5b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67fc5b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c67fc5b2')) {
      api.createRecord('c67fc5b2', component.options)
    } else {
      api.reload('c67fc5b2', component.options)
    }
    module.hot.accept("./zhenxieguyu.vue?vue&type=template&id=c67fc5b2&scoped=true&", function () {
      api.rerender('c67fc5b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/tianjiaoScoreManagement/zhenxieguyu.vue"
export default component.exports